function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("desc", null, "Created with Lunacy");

var _ref3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  x1: 0.14571428,
  y1: 0.42224878,
  x2: 0.8385714,
  y2: 0.91267943,
  id: "gradient_1"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#08103F"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#392F72"
})));

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M0 10.5469C0 13.0037 0.972281 15.3843 2.74177 17.2712C3.09197 18.7152 2.66691 20.245 1.61222 21.2997C1.17122 21.7408 1.48308 22.5 2.10938 22.5C4.113 22.5 6.04453 21.7152 7.47961 20.3309C8.89959 20.8376 10.402 21.0938 11.9531 21.0938C18.5442 21.0938 24 16.3628 24 10.5469C24 4.731 18.5442 0 11.9531 0C5.36203 0 0 4.731 0 10.5469ZM4.3125 10.5469C4.3125 9.38372 5.25872 8.4375 6.42188 8.4375C7.58503 8.4375 8.53125 9.38372 8.53125 10.5469C8.53125 11.71 7.58503 12.6563 6.42188 12.6563C5.25872 12.6563 4.3125 11.71 4.3125 10.5469ZM9.9375 10.5469C9.9375 9.38372 10.8837 8.4375 12.0469 8.4375C13.21 8.4375 14.1563 9.38372 14.1563 10.5469C14.1563 11.71 13.21 12.6563 12.0469 12.6563C10.8837 12.6563 9.9375 11.71 9.9375 10.5469ZM15.5625 10.5469C15.5625 9.38372 16.5087 8.4375 17.6719 8.4375C18.835 8.4375 19.7813 9.38372 19.7813 10.5469C19.7813 11.71 18.835 12.6563 17.6719 12.6563C16.5087 12.6563 15.5625 11.71 15.5625 10.5469Z",
  id: "Vector",
  fill: "url(#gradient_1)",
  fillRule: "evenodd",
  stroke: "none"
});

var SvgMessage = function SvgMessage(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "23px",
    viewBox: "0 0 24 23",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgMessage, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/message.e9023cd6.svg";
export { ForwardRef as ReactComponent };